export const SERVER_AUTH = 'https://api.production.ecommerce.neonmall.co/v1';
export const SERVER_MAHAMART = 'https://api.production.ecommerce.neonmall.co';
export const SERVER_LGS = 'https://api.production.logistics.neonmall.co';
export const AUTH_UI_URL = 'http://localhost:3005';
export const SERVER_ELGS = 'https://api-elgs.laconic.co.th';
